import { render, staticRenderFns } from "./RetoursClosedTable.vue?vue&type=template&id=2a65ec3a&scoped=true&lang=true&"
import script from "./RetoursClosedTable.vue?vue&type=script&lang=js&"
export * from "./RetoursClosedTable.vue?vue&type=script&lang=js&"
import style0 from "./RetoursClosedTable.vue?vue&type=style&index=0&id=2a65ec3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a65ec3a",
  null
  
)

export default component.exports